var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarKardexHover68X56(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 56,
    viewBox: "0 0 68 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8 21.98C30.1976 21.98 30.52 22.3024 30.52 22.7V33.3C30.52 33.6976 30.1976 34.02 29.8 34.02C29.4024 34.02 29.08 33.6976 29.08 33.3V22.7C29.08 22.3024 29.4024 21.98 29.8 21.98Z",
    fill: "CurrentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7336 27.4197C31.9989 27.1235 32.4541 27.0984 32.7503 27.3636L38.6803 32.6736C38.9765 32.9389 39.0016 33.3941 38.7364 33.6903C38.4711 33.9865 38.0159 34.0116 37.7197 33.7464L31.7897 28.4364C31.4935 28.1711 31.4684 27.7159 31.7336 27.4197Z",
    fill: "CurrentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1254 22.1973C38.4031 22.482 38.3974 22.9378 38.1127 23.2154L30.4227 30.7154C30.138 30.9931 29.6822 30.9874 29.4046 30.7027C29.1269 30.418 29.1326 29.9622 29.4173 29.6846L37.1073 22.1846C37.392 21.9069 37.8478 21.9126 38.1254 22.1973Z",
    fill: "CurrentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 31.47C24.9142 31.47 25.25 31.8058 25.25 32.22V35.39C25.25 36.1381 25.8565 36.75 26.61 36.75H29.78C30.1942 36.75 30.53 37.0858 30.53 37.5C30.53 37.9142 30.1942 38.25 29.78 38.25H26.61C25.0235 38.25 23.75 36.9619 23.75 35.39V32.22C23.75 31.8058 24.0858 31.47 24.5 31.47Z",
    fill: "CurrentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5 31.47C43.9142 31.47 44.25 31.8058 44.25 32.22V35.39C44.25 36.9765 42.9619 38.25 41.39 38.25H38.22C37.8058 38.25 37.47 37.9142 37.47 37.5C37.47 37.0858 37.8058 36.75 38.22 36.75H41.39C42.1381 36.75 42.75 36.1435 42.75 35.39V32.22C42.75 31.8058 43.0858 31.47 43.5 31.47Z",
    fill: "CurrentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.47 18.5C37.47 18.0858 37.8058 17.75 38.22 17.75H41.39C42.9765 17.75 44.25 19.0381 44.25 20.61V23.78C44.25 24.1942 43.9142 24.53 43.5 24.53C43.0858 24.53 42.75 24.1942 42.75 23.78V20.61C42.75 19.8619 42.1435 19.25 41.39 19.25H38.22C37.8058 19.25 37.47 18.9142 37.47 18.5Z",
    fill: "CurrentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.61 19.25C25.8619 19.25 25.25 19.8565 25.25 20.61V23.78C25.25 24.1942 24.9142 24.53 24.5 24.53C24.0858 24.53 23.75 24.1942 23.75 23.78V20.61C23.75 19.0235 25.0381 17.75 26.61 17.75H29.78C30.1942 17.75 30.53 18.0858 30.53 18.5C30.53 18.9142 30.1942 19.25 29.78 19.25H26.61Z",
    fill: "CurrentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarKardexHover68X56);
export default __webpack_public_path__ + "static/media/SIDEBAR_KARDEX_HOVER_68X56.3daec2bb372f8e450d26fc3fa229263c.svg";
export { ForwardRef as ReactComponent };